import React from "react";
import { Stack } from "@chakra-ui/react";
import Nav from "../components/navbar";
import MobileFloatingIsland from "../components/MobileFloatingIsland";
import MobileBottomSpacer from "../components/MobileBottomSpacer";

type AppContainerProps = {
  children: React.ReactNode;
  pageName?: string;
  mobileMenuItems?: any[]; // pass in items for MobileFloatingIsland
};

const AppContainer: React.FC<AppContainerProps> = ({
  children,
  pageName,
  mobileMenuItems = [],
}) => {
  return (
    <Stack minH="100dvh" spacing={0}>
      {/* Sticky header */}
      <Stack position="sticky" top={0} zIndex={10} width="full">
        <Nav pageName={pageName || ""} />
      </Stack>

      {/* Page content */}
      <Stack flex={1}>{children}</Stack>

      {/* Mobile floating nav (only shows on base) */}

      {/* <MobileFloatingIsland items={mobileMenuItems} /> */}
      <MobileBottomSpacer height={64} gap={16} />
    </Stack>
  );
};

export default AppContainer;
